import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";

const winQuotePrice = async (data: any) => {
  return await axiosInstance
    .patch("quotes/winPrice", data)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useWinQuotePriceMutation = () => {
  return useMutation({
    mutationFn: (data: any) => winQuotePrice(data),
    mutationKey: ["quotes"],
  });
};

export default useWinQuotePriceMutation;
